import { render, staticRenderFns } from "./PH2V.vue?vue&type=template&id=1e4cad64&scoped=true"
import script from "./PH2V.vue?vue&type=script&lang=js"
export * from "./PH2V.vue?vue&type=script&lang=js"
import style0 from "./PH2V.vue?vue&type=style&index=0&id=1e4cad64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4cad64",
  null
  
)

export default component.exports